import { HttpClient, HttpParams } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { SnackbarService } from './snackbar.service';
import { environment } from '../../environments/environment';
import { ConfigService } from './config.service';
import { map, Observable } from 'rxjs';
import { TableResponse } from '../components/table/table.interface';
import { DictionaryService } from './dictionary.service';
@Injectable({
  providedIn: 'root',
})
export class EvaluationService {
  http = inject(HttpClient);
  messageService = inject(SnackbarService);
  baseUrl = environment.apiBaseUrl;
  configService = inject(ConfigService);
  dictionaryService = inject(DictionaryService);

  timeRange = computed(() => {
    return this.configService.getApiDateTimeRange();
  });

  getTeamEvaluation = (filters: string[] = []): Observable<TableResponse> => {
    return this.http
      .post<TableResponse>(
        `${this.baseUrl}/evaluations/tables/team-evaluations-analytics`,
        {
          ...this.timeRange(),
          filters: filters.length
            ? {
              User: filters,
            }
            : undefined,
          getAvailableFilters: true,
        },
      )
      .pipe(
        map((res: any) => {
          if (res.success) {
            return res;
          } else {
            this.messageService.showError(this.dictionaryService.get('EvaluationError'));
            return {};
          }
        }),
      );
  };

  getUserEvaluation = (
    repId: string,
  ): Observable<TableResponse> => {
    return this.http
      .post(`${this.baseUrl}/evaluations/tables/user-evaluations-analytics/${repId}`, { ...this.timeRange() })
      .pipe(
        map((res: any) => {
          if (res.success) {
            return res;
          } else {
            this.messageService.showError(this.dictionaryService.get('EvaluationError'));
            return [];
          }
        }),
      );
  };

  getTeamMembers = (): Observable<{ names: string[]; ids: string[] }> => {
    return this.http
      .post(`${this.baseUrl}/evaluations/tables`, {
        ...this.timeRange(),
        page: 1,
      })
      .pipe(
        map((res: any) => {
          if (res.success) {
            return {
              names: res.data.rows.map((row: any) => row.Name as string),
              ids: res.data.rows.map((row: any) => row.repId as string),
            };
          } else {
            this.messageService.showError(this.dictionaryService.get('MembersListError'));
            return { names: [], ids: [] };
          }
        }),
      );
  };

  getTeamEvaluationReport = () => {
    const params = new HttpParams({
      fromObject: {
        ...this.timeRange(),
      }
    });
    return this.http.get(`${this.baseUrl}/evaluations/reports/team-evaluations-details`, {
      params
    },
    ).pipe(
      map((res: any) => {
        if (res.success) {
          return res.data.reportURL;
        } else {
          this.messageService.showError(this.dictionaryService.get('MembersListError'))
        }
      })
    )
  }
}
